import React from 'react';
import { Button, ButtonContainer } from '@vwfs-bronson/bronson-react';

export interface FromNavigationButtonsProps {
  canGoForward: boolean;
  disableForward?: boolean;
  disabledBackButton?: boolean;
  canGoBack?: boolean;
  backName?: string;
  forwardName: string;
  goBackHandler?: () => void;
  isNoVIN?: boolean;
  goForwardWithoutVINHandler?: () => void;
}

export const FormNavigationButtons = ({
  canGoForward,
  disableForward = false,
  disabledBackButton = false,
  canGoBack = false,
  backName = 'Précédent',
  forwardName = 'Suivant',
  goBackHandler,
  isNoVIN = false,
  goForwardWithoutVINHandler,
}: FromNavigationButtonsProps) => {
  const renderNextButton = () => {
    if (!canGoBack && !canGoForward) return <div />;
    if (!canGoForward && forwardName === null) return <div />;

    if (canGoForward && forwardName !== null) {
      return (
        <Button full type="submit" disabled={disableForward} name="test">
          {forwardName}
        </Button>
      );
    }

    if (!canGoForward && isNoVIN) {
      return (
        <Button full type="button" onClick={goForwardWithoutVINHandler}>
          {forwardName}
        </Button>
      );
    }

    if (!canGoForward && forwardName !== null) {
      return (
        <Button full disabled type="submit">
          {forwardName}
        </Button>
      );
    }

    return null;
  };

  return (
    <ButtonContainer center>
      {canGoBack && (
        <Button type="button" secondary disabled={disabledBackButton} full onClick={goBackHandler}>
          {backName}
        </Button>
      )}

      {renderNextButton()}
    </ButtonContainer>
  );
};
